import { Component, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'sphere-page-not-found',
    templateUrl: './page-not-found.component.html',
    imports: [MatButton, RouterLink, MatIcon],
    styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
